import _Vue, { PluginFunction } from 'vue';
import { hasFeature } from '../lib/feature';

declare module 'vue/types/vue' {
	// 3. Declare augmentation for Vue
	interface Vue {
		$feature: (item?: string) => boolean;
	}

	interface VueConstructor {
		$feature: (item?: string) => boolean;
	}
}

export const NgoFeaturePlugin: PluginFunction<string> = (Vue: typeof _Vue) => {
	Vue.$feature = function(item?: string): boolean {
		return hasFeature(item);
	};
	Vue.prototype.$feature = Vue.$feature;
};
